import { Styles } from 'material-ui';
import * as MaterialColors from 'components/Material/Styles/Colors';
import ColorManipulator from 'material-ui/lib/utils/color-manipulator';
const { Colors, Spacing } = Styles;

const primaryColor = MaterialColors.Colors.coursio;
const accentColor = MaterialColors.Colors.deepPurple;
const textColors = MaterialColors.Text;
const themeColors = MaterialColors.Theme.Light;

export default {
  spacing: Spacing,
  contentFontFamily: `'MaisonNeue-Book', sans-serif`,
  fontFamily: `'MaisonNeue-Book', sans-serif`,
  toolbar: {
    height: 60
  },
  palette: {
    primary1Color: primaryColor[500].material,
    primary2Color: primaryColor[600].material,
    primary3Color: MaterialColors.Colors.grey[300].material,
    accent1Color: accentColor[500].material,
    accent2Color: MaterialColors.Colors.grey[500].material,
    accent3Color: accentColor[100].material,
    textColor: textColors.Dark.text,
    alternateTextColor: textColors.Light.text,
    canvasColor: themeColors.background,
    cardColor: themeColors.card,
    borderColor: textColors.Dark.divider,
    primary1TextColor: textColors[primaryColor[500].text].text,
    primary2TextColor: textColors[primaryColor[700].text].text,
    primary3TextColor: textColors[primaryColor[100].text].text,
    accent1TextColor: textColors[accentColor[500].text].text,
    accent2TextColor: textColors[accentColor[700].text].text,
    accent3TextColor: textColors[accentColor[100].text].text,
    disabledColor: ColorManipulator.fade(Colors.darkBlack, 0.3),
    pickerHeaderColor: Colors.cyan500,
    clockCircleColor: ColorManipulator.fade(Colors.darkBlack, 0.07)
  }
};



// WEBPACK FOOTER //
// ./src/js/components/Material/Styles/CoursioTheme.js